export function formatComplaintResolution(resolutionObj) {
  if (!resolutionObj) {
    return '';
  }

  const sortedKeys = Object.keys(resolutionObj).sort((a, b) => {
    const numA = parseInt(a.replace(/\D/g, ''), 10);
    const numB = parseInt(b.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  return sortedKeys.map((key) => resolutionObj[key]).join('\n');
}
